import clsx from 'clsx';

import { getConditionalObject } from 'utils/data';

import { getPendingChangeOutlinedHighlightStyles } from '../shared/styles';

const getColorStyles = ({ error, disabled, palette }) =>
  clsx({
    [palette.text.error]: error,
    [palette.mode === 'dark' ? palette.text.disabled : 'rgba(0, 0, 0, 0.26)']: disabled,
    null: !error && !disabled,
  });

export const getStyles = ({ error, disabled, isFieldChanged, columns }) => ({
  controlLabel: {
    color: ({ palette }) => (error ? palette.text.error : null),
    width: 'fit-content',
    gap: '4px',
    margin: 0,
    paddingRight: '7px',
    zIndex: 1,

    ...getConditionalObject(isFieldChanged, () => getPendingChangeOutlinedHighlightStyles(columns)),

    '.MuiCheckbox-root': {
      padding: '7px',
    },

    '& .MuiFormControlLabel-asterisk': {
      marginLeft: '4px',
      lineHeight: '2rem',
      color: ({ palette }) => palette.text.error,
    },

    '& .checkbox-label': {
      color: ({ palette }) => `${getColorStyles({ error, disabled, palette })} !important`,
    },
  },
  checkbox: {
    color: ({ palette }) => (error ? palette.text.error : null),

    '& .checkbox-icon rect': {
      stroke: ({ palette }) => `${getColorStyles({ error, disabled, palette })} !important`,
    },
  },
});
